import { ApplicationsState } from './applications.types'

export default (): ApplicationsState => ({
  data: {},
  filters: {},
  meta: {
    genderList: [],
    occupationList: [],
    natureOfBusinessList: []
  }
})
